/**
* Team Callout JS
* -----------------------------------------------------------------------------
*
* All the JS for the Team Callout component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'team-callout',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.team-callout' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--team-callout' )[0], {
          type: 'loop',
          autoWidth: true,
          pagination: false,
          arrows: false,
          gap: '32px',
          direction: 'ltr',
          autoScroll: {
            speed: -0.5,
          },
        } );

        splide.mount( {AutoScroll} );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'team-callout', COMPONENT );
} )( app );
